/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
export const MICROSOFT_GRAPH_ENDPOINTS = new Set();
export const MICROSOFT_GRAPH_DEFAULT_ENDPOINT = 'https://graph.microsoft.com';
(() => {
    const endpoints = [
        MICROSOFT_GRAPH_DEFAULT_ENDPOINT,
        'https://graph.microsoft.us',
        'https://dod-graph.microsoft.us',
        'https://graph.microsoft.de',
        'https://microsoftgraph.chinacloudapi.cn'
    ];
    endpoints.forEach(endpoint => MICROSOFT_GRAPH_ENDPOINTS.add(endpoint));
})();
//# sourceMappingURL=IGraph.js.map